import { render, staticRenderFns } from "./FlashProduct.vue?vue&type=template&id=60212696&scoped=true"
import script from "./FlashProduct.vue?vue&type=script&lang=js"
export * from "./FlashProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60212696",
  null
  
)

export default component.exports